document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".quick-view-btn");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const handle = btn.getAttribute("data-product-handle");
    fetch(`/products/${handle}?view=quick-view`)
      .then((res) => res.text())
      .then((html) => {
        const popup = document.getElementById("quick-view-popup");
        const content = document.getElementById("quick-view-product");
        content.innerHTML = html;
        popup.classList.add("active");
        document.body.classList.add("quick-view-open");
        initQuickViewFeatures();
        
      })
    },
  true 
);
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-view-overlay") ||
    e.target.classList.contains("quick-view-close")
  ) {
    document.getElementById("quick-view-popup").classList.remove("active");
    document.body.classList.remove("quick-view-open");
  }
});

//  INITIALIZE QUICK VIEW FEATURES (Image Gallery & Accordion)

function initQuickViewFeatures() {
  const quickView = document.querySelector('.quick-view-modal');
  if (!quickView) return;

  const mainMedia = quickView.querySelector('#qvMainMedia');
  const thumbnails = quickView.querySelectorAll('.qv-thumbnails');
  const prevBtn = quickView.querySelector('.qv-prev');
  const nextBtn = quickView.querySelector('.qv-next');

  if (!mainMedia || !thumbnails.length) return;

  let currentIndex = 0;

  function updateMedia(index) {
    const thumb = thumbnails[index];
    if (!thumb) return;

    const mediaHTML = thumb.getAttribute('data-media-html');
    if (!mediaHTML) return;

    // Replace media safely
    mainMedia.innerHTML = mediaHTML;
    currentIndex = index;

    thumbnails.forEach((t, i) =>
      t.classList.toggle('active', i === index)
    );

const video = mainMedia.querySelector('video');
if (video) {
  video.pause();
  video.currentTime = 0;
  video.style.width = '100%';
  video.style.height = 'auto';
  video.load();
}

  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => updateMedia(index));
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const next = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      updateMedia(next);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const next = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      updateMedia(next);
    });
  }
}
// document.addEventListener('click', function (e) {
//   if (e.target.classList.contains('qv-qty-plus')) {
//     const input = e.target.closest('.qv-quantity')?.querySelector('.qv-qty-input');
//     if (input) input.value = parseInt(input.value || 1) + 1;
//   }

//   if (e.target.classList.contains('qv-qty-minus')) {
//     const input = e.target.closest('.qv-quantity')?.querySelector('.qv-qty-input');
//     if (input && parseInt(input.value) > 1) {
//       input.value = parseInt(input.value) - 1;
//     }
//   }
// });

document.addEventListener('click', function (e) {
  const qtyWrapper = e.target.closest('.qv-quantity');
  if (!qtyWrapper) return;

  const input = qtyWrapper.querySelector('.qv-qty-input');
  if (!input) return;

  const minQty = parseInt(input.dataset.min || input.min || 1, 10);
  const packQty = parseInt(input.step || 1, 10);

  let currentQty = parseInt(input.value || minQty, 10);

  // PLUS BUTTON
  if (e.target.classList.contains('qv-qty-plus')) {
    currentQty = currentQty + packQty;
    input.value = currentQty;
  }

  // MINUS BUTTON
  if (e.target.classList.contains('qv-qty-minus')) {
    currentQty = currentQty - packQty;

    if (currentQty < minQty) {
      currentQty = minQty;
    }

    input.value = currentQty;
  }
});
function initQuickViewFeatures() {
  const mainMedia = document.getElementById('qvMainMedia');
  const thumbnails = document.querySelectorAll('.qv-thumbnail');
  const prevBtn = document.querySelector('.qv-prev');
  const nextBtn = document.querySelector('.qv-next');

  if (!mainMedia || thumbnails.length === 0) return;

  let currentIndex = 0;

  function updateMedia(index) {
    const thumb = thumbnails[index];
    if (!thumb) return;

    mainMedia.innerHTML = thumb.dataset.mediaHtml;
    currentIndex = index;

    thumbnails.forEach((t, i) =>
      t.classList.toggle('active', i === index)
    );

    // Reset video size safely
    const video = mainMedia.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.style.width = '100%';
      video.style.height = 'auto';
      video.load();
    }
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => updateMedia(index));
  });

  prevBtn?.addEventListener('click', () => {
    updateMedia(currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1);
  });

  nextBtn?.addEventListener('click', () => {
    updateMedia(currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0);
  });

  // Initialize first media
  updateMedia(0);
}
document.addEventListener('click', function (e) {
  const header = e.target.closest('.qv-accordion-header');
  if (!header) return;

  const item = header.closest('.qv-accordion-item');
  const content = item.querySelector('.qv-accordion-content');
  const icon = item.querySelector('.qv-accordion-icon');

  const isOpen = item.classList.contains('active');

  // Close all other quick view accordions (optional but recommended)
  document.querySelectorAll('.qv-accordion-item.active').forEach(el => {
    el.classList.remove('active');
    el.querySelector('.qv-accordion-content').style.maxHeight = null;
    el.querySelector('.qv-accordion-icon').textContent = '+';
  });

  // Toggle current
  if (!isOpen) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
    icon.textContent = '–';
  }
});